import { Application } from '@hotwired/stimulus'
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers'
import ContentLoader from '@stimulus-components/content-loader'
import AutoSubmit from '@stimulus-components/auto-submit'

const application = Application.start()
const context = require.context('controllers', true, /_controller\.js$/)
application.register('content-loader', ContentLoader)
application.register('auto-submit', AutoSubmit)
application.load(definitionsFromContext(context))
